module.exports = __webpack_public_path__ + "assets/img/icon_loginLogo.39d261be.png";